import React, { useState } from "react";
import { getFlagUrl } from "@helpers/getFlagUrl";
import CountryIcon from "@assets/icons/CountryIcon";
import { alpha3ToAlpha2 } from "@utils/countryCodeMap";
import "./CountrySelect.sass";

const CountrySelect = ({
  countries,
  value,
  onChange,
  locale,
  placeholder = "Select country",
  error = false,
}) => {
  const [open, setOpen] = useState(false);

  const normalizeAlpha2 = (code) => {
    if (!code || typeof code !== "string") return "";
    return code.trim().toLowerCase();
  };

  const selected = countries.find((c) => {
    if (c.code === value) return true;

    const alpha2FromCountry = alpha3ToAlpha2[c.code];
    return normalizeAlpha2(alpha2FromCountry) === normalizeAlpha2(value);
  });

  return (
    <div className="country-select">
      <div
        className={`country-select__control bo-input__input ${
          !selected ? "is-placeholder" : ""
        } ${error ? "error" : ""}`}
        onClick={() => setOpen(!open)}
      >
        {selected ? (
          <>
            <img
              className="country-select__flag"
              src={getFlagUrl(selected)}
              alt=""
            />
            <span className="country-select__label">
              {locale === "ru" ? selected.label_ru : selected.label_en}
            </span>
          </>
        ) : (
          <>
            <CountryIcon className="country-select__placeholder-icon" />
            <span className="country-select__placeholder">{placeholder}</span>
          </>
        )}
      </div>

      {open && (
        <div className="country-select__dropdown">
          {countries.map((c) => {
            return (
              <div
                key={c.code}
                className="country-select__option"
                onClick={() => {
                  onChange(c.code);
                  setOpen(false);
                }}
              >
                <img
                  className="country-select__flag"
                  src={getFlagUrl(c)}
                  alt=""
                />
                <span className="country-select__label">
                  {locale === "ru" ? c.label_ru : c.label_en}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CountrySelect;
